export default __webpack_public_path__ + "2f5cae6580430506c1c8a03b1d3af127.png";